import { RevealProps } from "./types";
import "./reveal.scss";

const Reveal = ({
  delay = 0,
  children,
  className = "",
  revealType = "vertical",
}: RevealProps) => {
  const classes = ["reveal", className, revealType].join(" ");
  return (
    <div className={classes} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
};

export default Reveal;
